import { readState } from "@/__main__/app-state.mjs";
import { appURLs, FALLBACK_IMAGE_URL } from "@/app/constants.mjs";
import makeStrictKeysObject from "@/util/strict-keys-object.mjs";

const staticApexMediaURLs = makeStrictKeysObject({
  getLegendImage(id: string) {
    if (!id) return FALLBACK_IMAGE_URL;
    const {
      apex: {
        meta: { legends },
      },
    } = readState;
    return legends[id]
      ? legends[id].imageUrl
      : `${appURLs.CDN}/blitz/apex/legends/${id}.png`;
  },
  getWeaponImage(id: string) {
    if (!id) return FALLBACK_IMAGE_URL;
    const {
      apex: {
        meta: { weapons },
      },
    } = readState;
    return weapons[id]
      ? weapons[id].imageUrl
      : `${appURLs.CDN}/blitz/apex/weapons/${id}.png`;
  },
});

export default staticApexMediaURLs;
